var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls,on:{"click":_vm.handleClick,"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}},[_c('div',{ref:"tipElement",class:(_vm.prefixCls + "-rel")},[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{class:(_vm.prefixCls + "-popper " + _vm.prefixCls + "-popper-" + _vm.theme + " " + _vm.prefixCls + "-popper-" + _vm.placement),style:(_vm.styles),attrs:{"placement":_vm.placement}},[_vm._t("content")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/tip/tips.vue?vue&type=template&id=43899e85&
// module id = 164
// module chunks = 0